export const preparePlayerList = (playerList) => {
  if (!playerList?.length) return []

  return playerList.sort((a, b) => {
    if (a.bracket_seed && !b.bracket_seed) return -1;
    if (!a.bracket_seed && b.bracket_seed) return 1;
    if (a.bracket_seed < b.bracket_seed) return -1;
    if (a.bracket_seed > b.bracket_seed) return 1;

    return 0;
  })
}